import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { AiIntractionComponent } from './ai-intraction.component';
import { AiInteractionService } from './ai-interaction.service';
import { AiInteractionRoutingModule } from './ai-interaction-routing.module';



@NgModule({
  declarations: [
    AiIntractionComponent
  ],
  imports: [
    CommonModule,
        SharedModule,
        AiInteractionRoutingModule
  ],
  providers:[AiInteractionService],
  schemas: [
      CUSTOM_ELEMENTS_SCHEMA,
      NO_ERRORS_SCHEMA
    ]
})
export class AiIntractionModule { }
